




































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Authentication } from '@/components/Authentication';

@Component
export default class Navbar extends Vue {
  private email = '';
  private isAuthenticated = false;

  private created() {
    this.retrieveUser();
  }

  @Watch('$route')
  private onRouteChanged(newRoute: Route, oldRoute: Route) {
    this.retrieveUser();
  }

  private async retrieveUser() {
    Authentication.email.then((email) => {
      this.email = email;
    });
    Authentication.isAuthenticated.then((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
    });
  }

  private async logout() {
    await Authentication.signOut();
    this.$router.go(0);
  }
}
